/**
 * @fileoverview ホームページのメインコンポーネント
 *
 * このファイルでは、アプリケーションのホームページ（ルートURL）で表示される
 * メインコンテンツを定義しています。ユーザーがアプリケーションに初めて訪れた際に
 * 表示される最初のページです。
 */

/**
 * ホームページコンポーネント
 *
 * アプリケーションのトップページで表示されるメインコンテンツです。
 * ユーザーポータルの主要機能や概要を表示します。
 *
 * @returns {JSX.Element} ホームページの要素
 */

import { Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { useNavigate } from "@/router";
import { Card } from "@/components/card";
import { Button } from "@/components/button";
import { useEffect } from "react";
import { isSignedIn } from "@/api/isSignedIn";

export default function Top() {
  const bffOrigin = import.meta.env.VITE_BFF_ORIGIN;
  const authRequestUrl = `${bffOrigin}/v1/login`;

  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      const loginStatus = await isSignedIn();
      if (loginStatus) {
        navigate("/user");
      }
    })();
  });

  const [loading, { open: setLoading }] = useDisclosure(false);

  return (
    <Card
      title="ようこそ"
      description="JijZeptへのログインに必要なユーザー情報を管理します。"
    >
      <Stack className="flex justify-center">
        まずはサインインを行ってください。
        <div className="flex justify-end">
          <form
            action={authRequestUrl}
            method="POST"
            onSubmit={() => setLoading()}
          >
            <Button
              text="サインイン"
              type="submit"
              disabled={loading}
              loading={loading}
            />
          </form>
        </div>
      </Stack>
    </Card>
  );
}
